import { useState, useEffect } from 'react';
import { size, padStart } from 'lodash';
import { cpfMask, cnpjMask, unMask } from 'utils/mask';
import MaskedInput from 'components/MaskedInput';
import Button from 'components/Button';
import { Content, HContainer } from '../../../RegisterUpdate/styles';

type CpfCnpjInputSectionProps = {
  title?: string;
  buttonLabel?: string;
  onSubmit: (value: string, type: 'cpf' | 'cnpj') => void;
  onGoBack: () => void;
  defaultValue?: string;
  cpfOnly?: boolean;
};

export default function CpfCnpjInputSection({
  title = 'Digite o CPF ou CNPJ',
  buttonLabel = 'Carregar cadastro',
  onSubmit,
  onGoBack,
  defaultValue = '',
  cpfOnly = false,
}: CpfCnpjInputSectionProps) {
  const [identifier, setIdentifier] = useState(defaultValue);
  const [identifierType, setIdentifierType] = useState<'cpf' | 'cnpj'>('cpf');

  useEffect(() => {
    if (cpfOnly) {
      setIdentifierType('cpf');
      return;
    }

    if (defaultValue) {
      const cleaned = unMask(defaultValue, '[^0-9A-Za-z]');
      setIdentifierType(
        cleaned.length > 11 || /[A-Za-z]/.test(cleaned) ? 'cnpj' : 'cpf'
      );
    }
  }, [defaultValue, cpfOnly]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = unMask(event.target.value, '[^0-9A-Za-z]').toUpperCase();
    let newValue;

    if (cpfOnly) {
      newValue = cpfMask(value);
    } else if (value.length > 11 || /[A-Za-z]/.test(value)) {
      setIdentifierType('cnpj');
      newValue = cnpjMask(value);
    } else {
      setIdentifierType('cpf');
      newValue = cpfMask(value);
    }

    setIdentifier(newValue);
  };

  const handleClick = () => {
    const cleaned = unMask(identifier, '[^0-9A-Za-z]').toUpperCase();
    const padded = padStart(
      cleaned,
      cpfOnly ? 11 : identifierType === 'cnpj' ? 14 : 11,
      '0'
    );
    onSubmit(padded, cpfOnly ? 'cpf' : identifierType);
  };
  const isDisabled = cpfOnly
    ? size(unMask(identifier, '[^0-9A-Za-z]')) < 11
    : (identifierType === 'cpf' &&
        size(unMask(identifier, '[^0-9A-Za-z]')) < 11) ||
      (identifierType === 'cnpj' &&
        size(unMask(identifier, '[^0-9A-Za-z]')) < 14);

  return (
    <>
      <Content>
        <MaskedInput
          id="cpfCnpj"
          name="cpfCnpj"
          title={title}
          value={identifier}
          onChange={handleChange}
          placeholder="Digite o CPF ou CNPJ"
          MaskType={identifierType}
          maxInputLength={18}
        />
      </Content>
      <HContainer>
        <Button onClick={onGoBack} buttonTheme="goback">
          Voltar
        </Button>
        <Button onClick={handleClick} disabled={isDisabled}>
          {buttonLabel}
        </Button>
      </HContainer>
    </>
  );
}
